import {createReducer, on} from '@ngrx/store';
import {Params} from '@angular/router';
import {QueryParamsActions} from './query-params.actions';

export type QueryParamsState<RouteNameType extends string = string> = Record<RouteNameType, Params>;

export const INITIAL_QUERY_PARAMS_STATE: QueryParamsState = {};

export const queryParamsState = createReducer<QueryParamsState>(
  INITIAL_QUERY_PARAMS_STATE,
  on(QueryParamsActions.save, (state, {routeName, queryParams}) => ({
    ...state,
    [routeName]: queryParams
  })),
  on(QueryParamsActions.clear, (state, {routeName}) => ({
    ...state,
    [routeName]: {}
  }))
);
